import React from 'react';
import {
  Table as Tbl,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  TableFooter,
} from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

export const Row = withStyles(theme => ({
  root: {},
}))(TableRow);

export const HighlightableRow = withStyles(theme => ({
  root: {
    backgroundColor: '#FFFFFF !important',
    '&:hover': {
      backgroundColor: `${theme?.palette?.background?.default} !important`,
      cursor: 'pointer',
    },
  },
}))(TableRow);

export const Cell = withStyles(theme => ({
  head: {
    backgroundColor: '#EEF0F8',
    color: theme?.palette?.common?.black,
    fontWeight: 'bold',
    fontSize: 14,
  },
  body: {
    fontSize: 14,
    color: 'inherit',
  },
}))(TableCell);

export function HeaderCell({
  queryParams,
  setQueryParams,
  field,
  title,
  ...rest
}) {
  const { orderBy, order } = queryParams;

  function orderTable() {
    if (queryParams.orderBy === field) {
      setQueryParams(state => ({
        ...state,
        order: state.order === 'asc' ? 'desc' : 'asc',
      }));
    } else {
      setQueryParams(state => ({
        ...state,
        order: 'asc',
        orderBy: field,
      }));
    }
  }

  return (
    <Cell {...rest}>
      <TableSortLabel
        active={orderBy === field}
        direction={orderBy === field ? order : 'asc'}
        onClick={orderTable}
      >
        {title}
      </TableSortLabel>
    </Cell>
  );
}

export function Head({ children }) {
  return (
    <TableHead>
      <Row>{children}</Row>
    </TableHead>
  );
}

export const Body = TableBody;
export const Table = Tbl;
export const Footer = TableFooter;
